/**
 * AVA-475 — preset "standard notes" the surveyor can insert into a report.
 *
 * These are conveniences, not a controlled vocabulary: free text is also allowed
 * (spec D5), and inserting a preset APPENDS to whatever is already typed rather
 * than replacing it. A surveyor who has written a bespoke observation must never
 * lose it by reaching for a standard phrase.
 *
 * Mock-backed for the demo. When these become tenant-configurable they move
 * behind the verification service alongside the tolerance library.
 */
export const reportNotesMock = Object.freeze([
  'Verification carried out against the design model issued for construction.',
  'Point cloud registered to project control; accuracy within survey tolerance.',
  'Access restricted at time of survey; as-built point taken at nearest visible feature.',
  'Support installed within stated tolerance on all axes.',
  'Non-conformance raised — refer to NCR log.',
]);

export default reportNotesMock;
